import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase"; // adjust path if needed
import Header from "./header";

const bannerCollections = [
  { id: "pawnbroking_banner", label: "Pawnbroking Banner" },
  { id: "instantcash_banner", label: "Instant Cash Banner" },
  { id: "wesell_banner", label: "We Sell Banner" },
  { id: "buybacks_banner", label: "Buybacks Banner" },
];

export default function OtherBanners() {
  const [banners, setBanners] = useState({});
  const [loading, setLoading] = useState(false);

  // Fetch all banners
  const fetchBanners = async () => {
    const updatedData = {};
    for (let banner of bannerCollections) {
      const col = await getDocs(collection(db, banner.id));
      col.forEach((docSnap) => {
        updatedData[banner.id] = {
          docId: docSnap.id,
          imageUrl: docSnap.data().imageUrl,
        };
      });
    }
    setBanners(updatedData);
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  // Handle file upload
  const handleFileChange = async (e, bannerId) => {
    const file = e.target.files[0];
    if (!file) return;

    setLoading(true);

    try {
      const storageRef = ref(storage, `banners/${bannerId}/${file.name}`);
      await uploadBytes(storageRef, file);
      const imageUrl = await getDownloadURL(storageRef);

      const docRef = doc(db, bannerId, bannerId); // same docId as bannerId
      await updateDoc(docRef, { imageUrl });

      // Refresh banners
      fetchBanners();
      alert("Banner updated successfully.");
    } catch (err) {
      console.error("Upload error", err);
      alert("Error uploading image.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Header />
      <div className="banner-container">
        <h2>Other Banners</h2>
        <p>Manage your banners here.</p>
        {bannerCollections.map((banner) => (
          <div key={banner.id} className="banner-box">
            <h3>{banner.label}</h3>

            {banners[banner.id]?.imageUrl ? (
              <div
                className="banner-img"
                style={{
                  backgroundImage: `url(${banners[banner.id].imageUrl})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  width: "100%",
                  height: "300px", // or whatever height you want
                }}
                aria-label={banner.label}
              />
            ) : (
              <p>No image available</p>
            )}

            <label className="upload-btn">
              Update
              <input
                type="file"
                accept="image/*"
                hidden
                onChange={(e) => handleFileChange(e, banner.id)}
              />
            </label>
          </div>
        ))}
        {loading && <p className="loading-text">Uploading...</p>}
      </div>
    </div>
  );
}
